export default "/_next/static/images/modal1-a60ece67d731b4c43425c7897fcc54b0.png";